import { put, call } from 'redux-saga/effects';
import { fetchWithMisToken } from '../../../../utils/fetch-with-mis-token';
import {
    FETCH_LEADERBOARD_DATA,
    removeLeaderboardDataRequest,
    setLeaderboardData,
    setLeaderboardDataRequest
} from '../actions';

/**
 * @typedef {object} FetchLeaderboardDataAction
 * @property {object} payload
 * @property {string} [payload.seasonPid]
 * @property {string} [payload.teamId]
 */

/**
 * @param {FetchLeaderboardDataAction} action - The Redux action.
 */
export function* fetchLeaderboardData(action) {
    const { seasonPid, teamId } = action.payload;

    yield put(setLeaderboardDataRequest(action.payload));

    let data = {};

    if (seasonPid) {
        data = yield call(
            fetchWithMisToken,
            `${
                PULSE.app.environment.cfsApi
            }/brownlow/leaderboard/season/${seasonPid}${
                teamId ? `?teamId=${teamId}` : ''
            }`
        );

        if (data) {
            yield put(setLeaderboardData({ seasonPid, data }));
        }
    }

    yield put(removeLeaderboardDataRequest(action.payload));

    yield put(FETCH_LEADERBOARD_DATA.success(data));
}
